// API 관련 상수
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

// 앱 상수
export const APP_NAME = 'ABA Web';
export const APP_VERSION = '1.0.0';

// 라우트 경로
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  DASHBOARD_INFO: '/dashboard/info',
  DASHBOARD_USERS: '/dashboard/users',
  PROFILE: '/profile',
};

// 로컬 스토리지 키
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
};

// 사용자 타입
export const USER_TYPES = {
  ADMIN: 'admin',
  MOM: 'mom',
  TEACHER: 'teacher',
};

// 사용자 타입 한글 매핑
export const USER_TYPE_LABELS = {
  admin: '관리자',
  mom: '학부모',
  teacher: '치료사',
};

// 사용자 타입을 한글로 변환하는 헬퍼 함수
export const getUserTypeLabel = (type) => {
  return USER_TYPE_LABELS[type] || '알 수 없음';
};
